import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=46bad68e&scoped=true"
import script from "./ShopInfo.vue?vue&type=script&lang=js"
export * from "./ShopInfo.vue?vue&type=script&lang=js"
import style0 from "./ShopInfo.vue?vue&type=style&index=0&id=46bad68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bad68e",
  null
  
)

export default component.exports